<template>
    <div class="container-fluid content" v-if="team">
        <!-- Header mit Kontostand -->
        <balance-header :transient-balance-adjustment="-transientInvest"/>

        <!-- Team Wappen -->
        <div class="row mt-4">
            <div class="d-flex">
                <team-emblem size="32" :emblem-id="team.emblemId"/>
            </div>
            <div class="my-auto">
                <sakali-header :title="team.name"/>
                <sakali-user :user="user"/>
            </div>
        </div>
        <div class="mt-2 text-center">Einstellungen für das nächste Spiel</div>
        <team-management vue-if="team"
                         :team="team"
                         @update:team="loadTeam"
                         @update:transientInvest="this.transientInvest = $event"/>
    </div>
</template>

<script>
    import sakaliApi from '../sakali-api'
    import BalanceHeader from "../components/BalanceFixedTopWidget";
    import TeamManagement from "../components/team/TeamManagement";
    import {mapGetters, mapActions} from 'vuex'
    import 'vue-slider-component/theme/antd.css'

    export default {
        data(){
            return {
                team: null,
                transientInvest: 0
            }
        },
        computed: {
            ...mapGetters(['user']),
        },
        methods: {
            ...mapActions(['messageAction', 'handleErrorAction']),
            loadTeam() {
                sakaliApi.get('/teams/bycoach/' + this.user.id).then(response => {
                    this.team = response.data;
                }).catch(error => {
                    this.handleErrorAction(error)
                })
            }
        },
        mounted() {
            this.loadTeam()
        },
        components: {
            BalanceHeader,
            TeamManagement
        }
    }
</script>
